import { Icon as PhosphorIcon } from '@phosphor-icons/react'
import React from 'react'

import { Icon } from '@/components/ui/icon'

import * as S from './delivery-radio-option.styled'

export interface DeliveryRadioOptionProps {
  icon: PhosphorIcon
  title: string
  subtitle?: string
  active: boolean
  disabled?: boolean
  onClick: VoidFunction
}

export const DeliveryRadioOption = ({
  icon,
  title,
  subtitle,
  active,
  onClick,
  disabled = false,
}: DeliveryRadioOptionProps) => {
  const handleClick = () => {
    if (active || disabled) return
    onClick()
  }

  return (
    <S.Container $active={active} onClick={handleClick}>
      <S.Content>
        <Icon icon={icon} size="2.4rem" />
        <S.Texts>
          <S.Title>{title}</S.Title>
          {subtitle && <S.SubTitle>{subtitle}</S.SubTitle>}
        </S.Texts>
      </S.Content>
      {!disabled && <S.Radio $active={active} />}
    </S.Container>
  )
}
